<template>
  <div
    class="welcome"
    aria-label="Hi. I'm Matt, Human-centered Technologist"
    @click="completed ? $emit('scroll') : abort()"
  >
    <div class="banner">
      <!-- <div class="topspace"></div> -->
      <div
        class="focus"
        id="bgimage"
        :class="{ invisible: !showContent, transbgimage: !aborted }"
      ></div>
      <div class="fader"></div>
      <div
        class="focus txtimage"
        id="hi"
        :class="{ invisible: !showContent, transhi: !aborted }"
      ></div>
      <div
        class="focus txtimage"
        id="immatt"
        :class="{ invisible: !showContent, transimmatt: !aborted }"
      ></div>
      <div
        class="focus txtimage"
        id="hct"
        :class="{ invisible: !showContent, transhct: !aborted }"
      ></div>
      <!-- <div class="bottomspace"></div> -->
      <Drama class="drama" :kill="aborted" />
    </div>
    <Arrow
      :class="{ invisible: !showContent, transarrow: !aborted }"
      direction="down"
      @scroll="$emit('scroll')"
    />
  </div>
</template>

<script>
import Drama from "./Drama";
import Arrow from "./Arrow";

export default {
  name: "Welcome",
  components: {
    Drama,
    Arrow,
  },
  data: function () {
    return {
      showContent: false,
      aborted: false,
      completed: false,
    };
  },
  methods: {
    runsequence: function () {
      this.showContent = true;
      setTimeout(this.complete, 7500);
    },
    abort: function () {
      this.$emit("abort");
      this.aborted = true;
      this.completed = true;
    },
    complete: function () {
      this.completed = true;
      this.$emit("complete");
    },
  },
  mounted: function () {
    this.$nextTick(this.runsequence);
  },
};
</script>

<style scoped>
.welcome {
  scroll-snap-align: start;
  width: 100%;
  min-height: 100%;
  background-color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
}
.banner {
  display: grid;
  background-color: white;
  height: 100%;
  width: 100%;
  grid-template:
    "topspace topspace topspace" 1fr
    "leftwing focus rightwing" auto
    "bottomspace bottomspace bottomspace" 1fr /
    1fr auto 1fr;
}
.drama {
  grid-area: 2 / 1 / 3 / 4;
}
.topspace {
  grid-area: topspace;
  background-color: blue;
  min-height: 5vh;
}
.fader {
  z-index: 3;
  grid-area: 2 / 1 / 3 / 4;
  height: 100%;
  background: linear-gradient(
    180deg,
    #000000 0%,
    #000000 5%,
    rgba(0, 0, 0, 0) 10%,
    rgba(0, 0, 0, 0) 90%,
    #000000 95%,
    #000000 100%
  );
}
.focus {
  grid-area: focus;
  width: 99vw;
  height: 99vw;
  max-height: 85vh;
  max-width: 127.5vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-position-x: center;
  background-position-y: top;
  /* opacity: 100%; */
}

#bgimage {
  z-index: 2;
  background-image: url("../assets/BannerBG.png");
}
.transbgimage {
  transition: opacity 0.5s 3s;
}

.txtimage {
  z-index: 4;
}

#hi {
  background-image: url("../assets/hi.png");
}
.transhi {
  transition: opacity 0.5s 4s;
}

#immatt {
  background-image: url("../assets/immatt.png");
}
.transimmatt {
  transition: opacity 0.5s 5s;
}

#hct {
  background-image: url("../assets/HCT.png");
}
.transhct {
  transition: opacity 0.5s 6s;
}

.transarrow {
  transition: opacity 0.5s 7s;
}

.visible {
  opacity: 1;
}
.invisible {
  opacity: 0;
}
.topspace {
  grid-area: topspace;
  background-color: black;
}
.bottomspace {
  grid-area: bottomspace;
  background-color: black;
}
</style>
